"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParsedTrackingParams = exports.hasValidCategoryParam = exports.getIsAllReviews = exports.getParsedPathParams = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _memoize = _interopRequireDefault(require("hs-lodash/memoize"));

var _params = require("hub-http/helpers/params");

var Category = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/groupTags/Category"));

var CategorySlug = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/urlSlugs/CategorySlug"));

var SuperCategory = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/groupTags/SuperCategory"));

var SuperCategorySlug = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/urlSlugs/SuperCategorySlug"));

var GROUPED_CATEGORIES = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/groupTags/superCategoryGroups"));

var StorefrontCollection = _interopRequireWildcard(require("../constants/StorefrontCollection"));

var StorefrontCollectionSlug = _interopRequireWildcard(require("../constants/StorefrontCollectionSlug"));

var _constants = require("../constants");

var getCategoryFromSlug = (0, _memoize.default)(function (slug) {
  return Object.keys(Category).find(function (key) {
    return CategorySlug[key] === slug;
  });
});
var getSuperCategoryFromSlug = (0, _memoize.default)(function (slug) {
  return Object.keys(SuperCategory).find(function (key) {
    return SuperCategorySlug[key] === slug;
  });
});
var getCollectionFromSlug = (0, _memoize.default)(function (slug) {
  return Object.keys(StorefrontCollection).find(function (key) {
    return StorefrontCollectionSlug[key] === slug;
  });
});

var getParsedPathParams = function getParsedPathParams(_ref) {
  var category = _ref.category,
      collection = _ref.collection,
      superCategory = _ref.superCategory,
      page = _ref.page,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["category", "collection", "superCategory", "page"]);
  return (0, _extends2.default)({}, rest, {
    category: getCategoryFromSlug(category),
    collection: getCollectionFromSlug(collection),
    superCategory: getSuperCategoryFromSlug(superCategory),
    page: page ? parseInt(page, 10) : undefined
  });
};

exports.getParsedPathParams = getParsedPathParams;

var getIsAllReviews = function getIsAllReviews(match) {
  return match.path.endsWith('/:slug/reviews') && match.isExact;
};

exports.getIsAllReviews = getIsAllReviews;

var hasValidCategoryParam = function hasValidCategoryParam(params) {
  var _getParsedPathParams = getParsedPathParams(params),
      category = _getParsedPathParams.category,
      superCategory = _getParsedPathParams.superCategory;

  if (!(category && superCategory)) {
    return false;
  }

  var superCategoryGroup = GROUPED_CATEGORIES[superCategory];
  return superCategoryGroup && Object.values(superCategoryGroup).includes(category);
};

exports.hasValidCategoryParam = hasValidCategoryParam;

var getParsedTrackingParams = function getParsedTrackingParams() {
  if (window && window.location) {
    var params = (0, _params.parse)(window.location.search.slice(1));
    return Object.keys(params).reduce(function (final, key) {
      if (_constants.TRACKING_PARAMS.includes(key)) {
        final[key] = params[key];
      }

      return final;
    }, {});
  }

  return {};
};

exports.getParsedTrackingParams = getParsedTrackingParams;


//////////////////
// WEBPACK FOOTER
// ./js/utils/params.js
// module id = 161
// module chunks = 209 210 211 212